import { Message } from 'element-ui';
/**
 * @description 格式化列表数据 -- 数据字典转换, 事件按钮控制
 * @param {*} data
 */
export const formatTotalDataList = (data, dictData) => {
    if (!data.length) return [];
    data.forEach(e => {
        e.isOuterName = e.isOuter === 0 ? '否' : '是'; // 外部节点
        e.isAbnormalName = e.isAbnormal === 0 ? '是' : '否'; // 是否异常
        e.mobileOnlineName = e.mobileOnline === 0 ? '是' : '否'; // 是否在线
        e.typeName = t(e.type, dictData, 'OTP_TYPE'); // 类型
        e.deviceTypeName = t(e.deviceType, dictData, 'DEVICETYPE'); // 设备类型
        e.trackingChadanFlagName = t(e.trackingChadanFlag, dictData, 'OTP_TRACKING_CHADAN_FLAG'); // 是否推送查单系统
        e.trackingSourceName = t(e.trackingSource, dictData, 'OTP_TRACKING_SOURCE'); // 跟踪来源
        e.trackingWayName = t(e.trackingWay, dictData, 'OTP_TRACKING_WAY'); // 跟踪方式
        e.statusName = t(e.status, dictData, 'OTP_STATUS'); // 网络和GPS
    });
    return data;
};

const t = (key, dict, dicType) => {
    if (!key) return '';
    if (!dict[dicType]) {
        Message.warning(`未获取数据字典: ${dicType}`);
        return key;
    };
    return dict[dicType][key];
};